(function () {
  // Delivery date from Manila time, never the visitor's device clock
  var CUTOFF_HOUR = 19;
  function manilaParts(d) {
    var f = new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Manila', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false });
    var o = {}; f.formatToParts(d).forEach(function (p) { o[p.type] = p.value; });
    return { y: +o.year, m: +o.month, d: +o.day, h: +o.hour % 24 };
  }
  function deliveryDate() {
    var p = manilaParts(new Date());
    var add = p.h >= CUTOFF_HOUR ? 2 : 1;
    var dt = new Date(Date.UTC(p.y, p.m - 1, p.d + add, 4));
    var label = new Intl.DateTimeFormat('en-PH', { timeZone: 'Asia/Manila', weekday: 'short', month: 'short', day: 'numeric' }).format(dt);
    var iso = new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Manila' }).format(dt);
    return { label: label, iso: iso, afterCutoff: p.h >= CUTOFF_HOUR };
  }
  function paintDate() {
    var dd = deliveryDate();
    document.querySelectorAll('[data-abot-delivery-date]').forEach(function (el) { el.textContent = dd.label; });
    document.querySelectorAll('[data-abot-delivery-input]').forEach(function (el) { el.value = dd.iso + ' (' + dd.label + ')'; });
  }
  paintDate();
  document.addEventListener('shopify:section:load', paintDate);
  new MutationObserver(function () { if (document.querySelector('[data-abot-delivery-input]:not([value*="("])')) paintDate(); })
    .observe(document.body, { childList: true, subtree: true });

  // Quantity steppers
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.abot-qty button'); if (!b) return;
    var i = b.parentNode.querySelector('input'); var mn = b.dataset.min !== undefined ? +b.dataset.min : 1;
    var v = Math.max(mn, Math.min(+i.max || 20, (+i.value || 0) + (+b.dataset.q)));
    i.value = v;
  });

  // Add to cart without leaving the menu
  function money(c) { return '₱' + (c / 100).toLocaleString('en-PH', { maximumFractionDigits: 2 }); }
  function refreshBar() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-abot-hcount]').forEach(function (s) { s.textContent = c.item_count; s.classList.toggle('is-hidden', c.item_count === 0); });
      var bar = document.querySelector('[data-abot-cartbar]'); if (!bar) return;
      bar.classList.toggle('is-hidden', c.item_count === 0);
      bar.querySelector('[data-abot-count]').textContent = c.item_count;
      bar.querySelector('[data-abot-total]').textContent = money(c.total_price);
      document.querySelectorAll('.cart-count-bubble span[aria-hidden]').forEach(function (s) { s.textContent = c.item_count; });
      document.querySelectorAll('[data-abot-hcount]').forEach(function (s) { s.textContent = c.item_count; s.classList.toggle('is-hidden', c.item_count === 0); });
    });
  }
  function abotItems(f) {
    var items = [{ id: +f.id.value, quantity: +f.quantity.value || 1 }];
    var ad = f.querySelector('.abot-addon');
    if (ad) { var n = +ad.querySelector('input').value || 0; if (n > 0) items.push({ id: +ad.dataset.addonId, quantity: n, properties: { 'For': ad.dataset.addonFor } }); }
    return items;
  }
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-abot-add]'); if (!f) return;
    e.preventDefault();
    var btn = f.querySelector('.abot-add__btn'); btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: abotItems(f) }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { var ai = f.querySelector('.abot-addon input'); if (ai) ai.value = 0; f.classList.add('is-added'); btn.textContent = 'Added'; setTimeout(function () { btn.textContent = 'Add'; f.classList.remove('is-added'); }, 1400); refreshBar(); })
      .catch(function (err) { btn.textContent = (err && err.status === 422) ? 'Sold out' : 'Try again'; })
      .finally(function () { btn.disabled = false; });
  });
})();

// v2: menu tabs
(function () {
  var grid = document.querySelector('.abot-mgrid'); if (!grid) return;
  var cards = [].slice.call(grid.querySelectorAll('.abot-mcard'));
  var tabs = [].slice.call(document.querySelectorAll('.abot-tab'));
  function show(key) {
    tabs.forEach(function (t) { var on = t.dataset.tab === key; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on); });
    cards.forEach(function (c) {
      var vis = key === 'all' || (key === 'pick' ? c.dataset.pick === 'true' : c.dataset.type === key);
      c.classList.toggle('is-hidden', !vis);
    });
  }
  tabs.forEach(function (t) { t.addEventListener('click', function () { show(t.dataset.tab); }); });
  var all = document.querySelector('[data-tab-all]');
  if (all) all.addEventListener('click', function () { show('all'); tabs.forEach(function (t) { t.classList.remove('is-active'); }); });
  var map = { 'm-rice': 'rice-meal', 'm-pancit': 'pancit', 'm-coffee': 'coffee', 'm-add-on': 'add-on', 'm-addon': 'add-on' };
  function fromHash(h) { h = (h || '').replace(/^.*#/, ''); if (map[h]) { show(map[h]); var m = document.getElementById('menu'); if (m) m.scrollIntoView({ behavior: 'smooth' }); return true; } return false; }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href*="#m-"]'); if (!a) return;
    if (a.pathname === location.pathname && fromHash(a.hash)) e.preventDefault();
  });
  show('pick');
  fromHash(location.hash);
})();


// Shake It Pancit product page: always offer the Chicken Tender add-on
(function () {
  var A = window.abotAddon; if (!A || A.page !== 'product' || A.handle !== A.pancitHandle || !A.available || !A.tenderId) return;
  var form = document.querySelector('form[action*="/cart/add"][data-type="add-to-cart-form"], product-form form');
  if (!form) return;
  var btns = form.querySelector('.product-form__buttons') || form.querySelector('[type=submit]');
  var box = document.createElement('div');
  box.className = 'abot-addon abot-addon--pdp';
  box.innerHTML = '<span class="abot-addon__label">+ Chicken Tender <b>\u20b1' + (A.price / 100) + '/pc</b></span>' +
    '<div class="abot-qty abot-qty--sm"><button type="button" data-q="-1" data-min="0" aria-label="Fewer tenders">\u2212</button>' +
    '<input type="number" value="0" min="0" max="10" aria-label="Chicken tenders to add">' +
    '<button type="button" data-q="1" data-min="0" aria-label="More tenders">+</button></div>';
  (btns && btns.parentNode ? btns.parentNode.insertBefore(box, btns) : form.appendChild(box));
  form.addEventListener('submit', function (e) {
    e.preventDefault(); e.stopImmediatePropagation();
    var id = +(form.querySelector('[name=id]') || {}).value;
    var q = +((document.querySelector('input[name=quantity][form="' + form.id + '"]') || form.querySelector('[name=quantity]') || {}).value) || 1;
    var n = +box.querySelector('input').value || 0;
    var items = [{ id: id, quantity: q }];
    if (n > 0) items.push({ id: A.tenderId, quantity: n, properties: { 'For': 'Shake It Pancit' } });
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw r; location.href = '/cart'; })
      .catch(function () { alert('Sorry, that could not be added. Please try again.'); });
  }, true);
})();


// Favorites (saved on this device)
(function () {
  var KEY = 'abot:favs';
  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
  var favs = read();
  function money(c) { return '\u20b1' + (c / 100).toLocaleString('en-PH', { maximumFractionDigits: 2 }); }
  function paint() {
    document.querySelectorAll('[data-fav-toggle]').forEach(function (b) { b.setAttribute('aria-pressed', favs.indexOf(b.dataset.favToggle) > -1 ? 'true' : 'false'); });
    document.querySelectorAll('[data-fav-count]').forEach(function (s) { s.textContent = favs.length; s.classList.toggle('is-hidden', favs.length === 0); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-fav-toggle]'); if (!b) return;
    e.preventDefault(); var h = b.dataset.favToggle, i = favs.indexOf(h);
    if (i > -1) favs.splice(i, 1); else favs.push(h);
    write(favs); paint(); if (!panel.hidden) render();
  });
  var panel = document.querySelector('[data-fav-panel]'); if (!panel) { paint(); return; }
  var list = panel.querySelector('[data-fav-list]'), empty = panel.querySelector('[data-fav-empty]');
  function render() {
    list.innerHTML = ''; empty.hidden = favs.length > 0;
    favs.forEach(function (h) {
      fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (p) {
        var v = p.variants.find(function (x) { return x.available; }) || p.variants[0];
        var row = document.createElement('div'); row.className = 'abot-fav__item';
        var img = p.featured_image ? '<img src="' + p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" loading="lazy">' : '<span class="abot-fav__ph"></span>';
        row.innerHTML = img + '<div class="abot-fav__meta"><b></b><span>' + money(v.price) + '</span><br><button type="button" class="abot-fav__rm">Remove</button></div>' +
          (v.available ? '<button type="button" class="abot-btn abot-btn--rust">Add</button>' : '<span class="abot-soldout">Sold out</span>');
        row.querySelector('b').textContent = p.title;
        row.querySelector('.abot-fav__rm').onclick = function () { favs.splice(favs.indexOf(h), 1); write(favs); paint(); render(); };
        var add = row.querySelector('.abot-btn');
        if (add) add.onclick = function () {
          add.disabled = true;
          fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) })
            .then(function (r) { add.textContent = r.ok ? 'Added' : 'Try again'; return fetch('/cart.js'); }).then(function (r) { return r.json(); })
            .then(function (c) { document.querySelectorAll('[data-abot-hcount]').forEach(function (s) { s.textContent = c.item_count; s.classList.toggle('is-hidden', c.item_count === 0); }); })
            .finally(function () { setTimeout(function () { add.disabled = false; add.textContent = 'Add'; }, 1200); });
        };
        list.appendChild(row);
      }).catch(function () { favs.splice(favs.indexOf(h), 1); write(favs); paint(); });
    });
  }
  function open() { panel.hidden = false; document.body.style.overflow = 'hidden'; render(); panel.querySelector('.abot-fav__x').focus(); }
  function close() { panel.hidden = true; document.body.style.overflow = ''; }
  document.querySelectorAll('[data-fav-open]').forEach(function (b) { b.addEventListener('click', open); });
  panel.querySelectorAll('[data-fav-close]').forEach(function (b) { b.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) close(); });
  paint();
})();

// Cart: lobby delivery vs self pick-up
(function () {
  function apply(root) {
    var box = (root || document).querySelector('[data-abot-fulfil]'); if (!box) return;
    var sel = box.querySelector('input[name="attributes[Fulfilment]"]:checked');
    var mode = sel ? sel.value : 'Lobby delivery';
    box.querySelectorAll('[data-show-for]').forEach(function (el) {
      var on = el.getAttribute('data-show-for') === mode;
      el.hidden = !on;
      el.querySelectorAll('input,select').forEach(function (f) { if (f.id === 'abot-building' || f.id === 'abot-window') { f.required = on; if (!on) f.value = ''; } });
    });
  }
  document.addEventListener('change', function (e) { if (e.target.name === 'attributes[Fulfilment]') apply(); });
  apply();
  new MutationObserver(function () { apply(); }).observe(document.body, { childList: true, subtree: true });
})();
